import C from "@/utils/rule/constant";
import BaseCalculator from "./BaseCalculator";

class MP extends BaseCalculator {
    /**
     * 胸腰差比
     * @type {number}
     */
    ratio_xy = 0;
    /**
     * 变化加放-体型
     * @type {number}
     */
    c_tx = 0;
    /**
     * 变化加放-胸比肩
     * @type {number}
     */
    c_xj = 0;
    v_xj = 0;
    /**
     * 变化加放-腰比胸
     * @type {number}
     */
    c_yx = 0;
    v_yx = 0;
    /**
     * 变化加放-胸比臀
     * @type {number}
     */
    c_xt = 0;
    v_xt = 0;
    /**
     * 变化加放-腰比臀
     * @type {number}
     */
    c_yt = 0;
    v_yt = 0;
    /**
     * @type {number}
     */
    c_tt = 0;
    v_tt = 0;
    /**
     * 特殊加放-胸围
     * @type {number}
     */
    s_xw = 0;
    /**
     * 特殊加放-中腰
     * @type {number}
     */
    s_zy = 0;
    /**
     * 特殊加放-下摆
     * @type {number}
     */
    s_xb = 0;
    /**
     * 特殊加放-袖肥
     * @type {number}
     */
    s_xf = 0;

    body = {
        [C.B_JXTZ_ST]: {
            平肩: -1,
            标准: 0,
            溜肩: 1,
            斜肩: 2
        },
        [C.B_TX_C]: {
            正常: 0,
            挺胸: 1,
            壮硕: 1.5,
            广阔: 2
        },
        [C.B_TB_B]: {
            微驼: 1,
            正常: 0,
            倾斜: -.5,
            驼背: 2
        },
        [C.B_TD_B]: {
            福态: 1,
            富态: 2,
            平腹: 0,
            将军肚: 3
        }
    };

    /**
     * 成衣参数key和计算公式
     * @type {{[p: string]: function(*, *, *): *}}
     * 匹配正则 ((base)|(net)|(plus))\[C\.(C|N)([A-Z_])*\]
     */
    complete_size = {
            [C.PREFERENCE_FITTED]: {
                [C.C_LW_CL]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL]));
                },
                [C.C_HYC_BCL]: function (net, base, plus, complete) {
                    return ((parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL]));
                },
                [C.C_JK_SW]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) + parseFloat(this.c_xj));
                },
                [C.C_XK_CW]: function (net, base, plus, complete) {
                    return (parseFloat(complete[C.C_JK_SW]) - 4 + (parseFloat(net[C.N_XK_CW]) -parseFloat(net[C.N_ZJK_SW])) * .25 + parseFloat(this.c_tx));
                },
                [C.C_BK_BW]: function (net, base, plus, complete) {
                    return (parseFloat(complete[C.C_JK_SW]) - 2 + (parseFloat(net[C.N_BK_BW]) -parseFloat(net[C.N_ZJK_SW])) * .25 + parseFloat(this.c_tx));
                },
                [C.C_XW_CL]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL] + parseFloat(this.s_xw)));
                },
                [C.C_ZY_MW]: function (net, base, plus, complete) {
                    return (parseFloat(complete[C.C_XW_CL]) + parseFloat(plus[C.C_ZY_MW]) + parseFloat(net[C.N_ZYW_MWL]) + parseFloat(this.s_zy) + parseFloat(this.c_yx) + 10) / 2 + parseFloat(base[C.C_ZY_MW]) - parseFloat(this.c_tx);
                },
                [C.C_XB_HC]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC]) + parseFloat(this.s_xb) + parseFloat(this.c_xt) + parseFloat(complete[C.C_XW_CL]) - 2) /2;
                },
                [C.C_XC_SL]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_CXC_LSL]) + parseFloat(base[C.C_XC_SL]) + parseFloat(plus[C.C_XC_SL]));
                },
                [C.C_XF_B]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B]) + parseFloat(this.s_xf));
                },
                [C.C_XK_SO]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_SWW_TL]) + parseFloat(base[C.C_XK_SO]) + parseFloat(plus[C.C_XK_SO]));
                },
            },
            [C.PREFERENCE_NORMAL]: {
                [C.C_LW_CL]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL]));
                },
                [C.C_HYC_BCL]: function (net, base, plus, complete) {
                    return ((parseFloat(net[C.N_HZC_BML]) + this.height * 0.395) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL]));
                },
                [C.C_JK_SW]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) + parseFloat(this.c_xj));
                },
                [C.C_XK_CW]: function (net, base, plus, complete) {
                    return (parseFloat(complete[C.C_JK_SW]) - 3 + (parseFloat(net[C.N_XK_CW]) -parseFloat(net[C.N_ZJK_SW])) * .25 + parseFloat(this.c_tx));
                },
                [C.C_BK_BW]: function (net, base, plus, complete) {
                    return (parseFloat(complete[C.C_JK_SW]) - 1.5 + (parseFloat(net[C.N_BK_BW]) -parseFloat(net[C.N_ZJK_SW])) * .25 + parseFloat(this.c_tx));
                },
                [C.C_XW_CL]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL] + parseFloat(this.s_xw)));
                },
                [C.C_ZY_MW]: function (net, base, plus, complete) {
                    return (parseFloat(complete[C.C_XW_CL]) + parseFloat(plus[C.C_ZY_MW]) + parseFloat(net[C.N_ZYW_MWL]) + parseFloat(this.s_zy) + parseFloat(this.c_yx) + 10) / 2 + parseFloat(base[C.C_ZY_MW]) - parseFloat(this.c_tx);
                },
                [C.C_XB_HC]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC]) + parseFloat(this.s_xb) + parseFloat(this.c_xt) + parseFloat(complete[C.C_XW_CL]) - 2) /2;
                },
                [C.C_XC_SL]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_CXC_LSL]) + parseFloat(base[C.C_XC_SL]) + parseFloat(plus[C.C_XC_SL]));
                },
                [C.C_XF_B]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B]) + parseFloat(this.s_xf));
                },
                [C.C_XK_SO]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_SWW_TL]) + parseFloat(base[C.C_XK_SO]) + parseFloat(plus[C.C_XK_SO]));
                },
            },
            [C.PREFERENCE_LOOSE]: {
                [C.C_LW_CL]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_LW_CL]) + parseFloat(base[C.C_LW_CL]) + parseFloat(plus[C.C_LW_CL]));
                },
                [C.C_HYC_BCL]: function (net, base, plus, complete) {
                    return ((parseFloat(net[C.N_HZC_BML]) + this.height * 0.4) / 2 + parseFloat(base[C.C_HYC_BCL]) + parseFloat(plus[C.C_HYC_BCL]));
                },
                [C.C_JK_SW]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_ZJK_SW]) + parseFloat(base[C.C_JK_SW]) + parseFloat(plus[C.C_JK_SW]) + parseFloat(this.c_xj));
                },
                [C.C_XK_CW]: function (net, base, plus, complete) {
                    return (parseFloat(complete[C.C_JK_SW]) - 4 + (parseFloat(net[C.N_XK_CW]) -parseFloat(net[C.N_ZJK_SW])) * .25 + parseFloat(this.c_tx));
                },
                [C.C_BK_BW]: function (net, base, plus, complete) {
                    return (parseFloat(complete[C.C_JK_SW]) - 2 + (parseFloat(net[C.N_BK_BW]) -parseFloat(net[C.N_ZJK_SW])) * .25 + parseFloat(this.c_tx));
                },
                [C.C_XW_CL]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_XW_CL]) + parseFloat(base[C.C_XW_CL]) + parseFloat(plus[C.C_XW_CL] + parseFloat(this.s_xw)));
                },
                [C.C_ZY_MW]: function (net, base, plus, complete) {
                    return (parseFloat(complete[C.C_XW_CL]) + parseFloat(plus[C.C_ZY_MW]) + parseFloat(net[C.N_ZYW_MWL]) + parseFloat(this.s_zy) + parseFloat(this.c_yx) + 10) / 2 + parseFloat(base[C.C_ZY_MW]) - parseFloat(this.c_tx);
                },
                [C.C_XB_HC]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_XB_HC]) + parseFloat(plus[C.C_XB_HC]) + parseFloat(this.s_xb) + parseFloat(this.c_xt) + parseFloat(complete[C.C_XW_CL]) - 2) /2;
                },
                [C.C_XC_SL]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_CXC_LSL]) + parseFloat(base[C.C_XC_SL]) + parseFloat(plus[C.C_XC_SL]));
                },
                [C.C_XF_B]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_SBW_UAL]) + parseFloat(base[C.C_XF_B]) + parseFloat(plus[C.C_XF_B]) + parseFloat(this.s_xf));
                },
                [C.C_XK_SO]: function (net, base, plus, complete) {
                    return (parseFloat(net[C.N_SWW_TL]) + parseFloat(base[C.C_XK_SO]) + parseFloat(plus[C.C_XK_SO]));
                },
            }
    };

    /**
     * 覆盖父类方法
     * @param size
     */
    setNetSize(size) {
        super.setNetSize(size);
        // 变化加放 Start
        let somatotype = this.custom_somatotype || this.default_somatotype;
        switch (somatotype) {
            case C.SOMATOTYPE_A:
                this.c_tx = 0;
                break;
            case C.SOMATOTYPE_B:
                this.c_tx = 0;
                break;
            case C.SOMATOTYPE_C:
                this.c_tx = 0;
                break;
            case C.SOMATOTYPE_D:
                this.c_tx = 0.5;
                break;
            case C.SOMATOTYPE_Y:
                this.c_tx = 0.5;
                break;
            case C.SOMATOTYPE_T:
                this.c_tx = 1;
                break;
        }
        this.v_xj = this.net_size[C.N_XW_CL] / 2 - this.net_size[C.N_ZJK_SW];
        if (this.v_xj >= 3) {
            this.c_xj = 0.5;
        } else if (this.v_xj >= 2) {
            this.c_xj = 0;
        } else if (this.v_xj >= 1) {
            this.c_xj = -0.5;
        } else {
            this.c_xj = -1;
        }
        this.v_yx = this.net_size[C.N_ZYW_MWL] - this.net_size[C.N_XW_CL];
        if (this.v_yx <= -14) {
            this.c_yx = 2;
        } else if (this.v_yx <= -9) {
            this.c_yx = 1;
        } else if (this.v_yx <= -4) {
            this.c_yx = 0;
        } else {
            this.c_yx = 0;
        }
        this.v_xt = this.net_size[C.N_XW_CL] - this.net_size[C.N_TW_HL];
        if (this.v_xt <= -10) {
            this.c_xt = -3;
        } else if (this.v_xt <= -7) {
            this.c_xt = -2;
        } else if (this.v_xt <= -4) {
            this.c_xt = -1;
        } else if (this.v_xt <= -1) {
            this.c_xt = 0;
        } else if (this.v_xt <= 2) {
            this.c_xt = 1;
        } else {
            this.c_xt = 2;
        }
        this.v_yt = this.net_size[C.N_KYW_TWL] - this.net_size[C.N_TW_HL];
        if (this.v_yt <= -16) {
            this.c_yt = -2;
        } else if (this.v_yt <= -13) {
            this.c_yt = -1;
        } else if (this.v_yt <= -10) {
            this.c_yt = 0;
        } else if (this.v_yt <= -7) {
            this.c_yt = 1;
        } else if (this.v_yt <= -4) {
            this.c_yt = 2;
        } else {
            this.c_yt = 3;
        }
        this.v_tt = this.net_size[C.N_TW_HL] / 2 - this.net_size[C.N_DTW_LL];
        if (this.v_tt <= -13) {
            this.c_tt = 2;
        } else if (this.v_tt <= -11) {
            this.c_tt = 1;
        } else if (this.v_tt <= -9) {
            this.c_tt = 0;
        } else if (this.v_tt <= -7) {
            this.c_tt = -1;
        } else if (this.v_tt <= -5) {
            this.c_tt = -2;
        } else {
            this.c_tt = -3;
        }
        // 变化加放 End

        // 特殊加放 Start
        if (this.net_size[C.N_XW_CL] <= 82) {
            this.s_xw = 3;
        } else if (this.net_size[C.N_XW_CL] <= 84.5) {
            this.s_xw = 2;
        } else if (this.net_size[C.N_XW_CL] <= 87) {
            this.s_xw = 1;
        } else if (this.net_size[C.N_XW_CL] <= 116) {
            this.s_xw = 0;
        } else {
            this.s_xw = -1;
        }
        if (this.net_size[C.N_ZYW_MWL] <= 72) {
            this.s_zy = 2;
        } else if (this.net_size[C.N_ZYW_MWL] <= 74) {
            this.s_zy = 1;
        } else if (this.net_size[C.N_ZYW_MWL] <= 76) {
            this.s_zy = 0;
        } else if (this.net_size[C.N_ZYW_MWL] <= 106) {
            this.s_zy = 0;
        } else {
            this.s_zy = 0.5;
        }
        if (this.net_size[C.N_TW_HL] <= 82) {
            this.s_xb = 3;
        } else if (this.net_size[C.N_TW_HL] <= 84) {
            this.s_xb = 2;
        } else if (this.net_size[C.N_TW_HL] <= 86) {
            this.s_xb = 1;
        } else if (this.net_size[C.N_TW_HL] <= 112) {
            this.s_xb = 0;
        } else {
            this.s_xb = -1;
        }
        if (this.net_size[C.N_SBW_UAL] <= 25) {
            this.s_xf = 1.5;
        } else if (this.net_size[C.N_SBW_UAL] <= 26) {
            this.s_xf = 1;
        } else if (this.net_size[C.N_SBW_UAL] <= 27) {
            this.s_xf = 0.5;
        } else if (this.net_size[C.N_SBW_UAL] <= 40) {
            this.s_xf = 0;
        } else {
            this.s_xf = -1;
        }
        // 特殊加放 End

        // 计算胸腰差比
        this.ratio_xy =
            (this.net_size[C.N_ZYW_MWL] / this.net_size[C.N_XW_CL] - 1) * 100;
    }

    /**
     * 穿衣偏好的加放基础值
     * @param preference
     * @returns {*}
     */
    base(preference) {
        let data = {
            [C.PREFERENCE_FITTED]: {
                [C.C_LW_CL]: 0,
                [C.C_HYC_BCL]: 0,
                [C.C_JK_SW]: -0.5,
                [C.C_XK_CW]: 0,
                [C.C_BK_BW]: 0,
                [C.C_XW_CL]: -2,
                [C.C_ZY_MW]: -1,
                [C.C_XB_HC]: -2,
                [C.C_XC_SL]: 0,
                [C.C_XF_B]: -1,
                [C.C_XK_SO]: 0
            },
            [C.PREFERENCE_NORMAL]: {
                [C.C_LW_CL]: 0,
                [C.C_HYC_BCL]: 0,
                [C.C_JK_SW]: 0,
                [C.C_XK_CW]: 0,
                [C.C_BK_BW]: 0,
                [C.C_XW_CL]: 0,
                [C.C_ZY_MW]: 0,
                [C.C_XB_HC]: 0,
                [C.C_XC_SL]: 0,
                [C.C_XF_B]: 0,
                [C.C_XK_SO]: 0
            },
            [C.PREFERENCE_LOOSE]: {
                [C.C_LW_CL]: 1,
                [C.C_HYC_BCL]: 1,
                [C.C_JK_SW]: 1,
                [C.C_XK_CW]: 0,
                [C.C_BK_BW]: 0,
                [C.C_XW_CL]: 2,
                [C.C_ZY_MW]: 1,
                [C.C_XB_HC]: 2,
                [C.C_XC_SL]: 1,
                [C.C_XF_B]: 1.5,
                [C.C_XK_SO]: 1
            }
        };

        return data[preference];
    }

    /**
     * 加放量值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    plus(preference) {
        let data = {
            [C.C_XK_CW]: 0,
            [C.C_BK_BW]: 0
        };
        let somatotype = this.custom_somatotype || this.default_somatotype;
        switch (preference) {
            case C.PREFERENCE_FITTED:
                if (somatotype == C.SOMATOTYPE_A) {
                    data[C.C_LW_CL] = 2.5;
                    data[C.C_HYC_BCL] = 2;
                    data[C.C_JK_SW] = -1;
                    data[C.C_XW_CL] = 8.5;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 6;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 8.5;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_B) {
                    data[C.C_LW_CL] = 2.5;
                    data[C.C_HYC_BCL] = 2;
                    data[C.C_JK_SW] = -1;
                    data[C.C_XW_CL] = 8;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 5;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 8;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_C) {
                    data[C.C_LW_CL] = 2;
                    data[C.C_HYC_BCL] = 2.5;
                    data[C.C_JK_SW] = -.5;
                    data[C.C_XW_CL] = 7.5;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 5;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 7.5;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_D) {
                    data[C.C_LW_CL] = 2;
                    data[C.C_HYC_BCL] = 3;
                    data[C.C_JK_SW] = -.5;
                    data[C.C_XW_CL] = 7;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 4.5;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 7;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_Y) {
                    data[C.C_LW_CL] = 3;
                    data[C.C_HYC_BCL] = 3;
                    data[C.C_JK_SW] = -1.5;
                    data[C.C_XW_CL] = 11;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 8;
                    data[C.C_XC_SL] = 0;
                    data[C.C_XF_B] = 9.5;
                    data[C.C_XK_SO] = 6;
                }
                if (somatotype == C.SOMATOTYPE_T) {
                    data[C.C_LW_CL] = 2;
                    data[C.C_HYC_BCL] = 3;
                    data[C.C_JK_SW] = -.5;
                    data[C.C_XW_CL] = 6;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 5;
                    data[C.C_XC_SL] = 0;
                    data[C.C_XF_B] = 7;
                    data[C.C_XK_SO] = 5;
                }
                break;
            case C.PREFERENCE_NORMAL:
                if (somatotype == C.SOMATOTYPE_A) {
                    data[C.C_LW_CL] = 2.5;
                    data[C.C_HYC_BCL] = 2;
                    data[C.C_JK_SW] = -1;
                    data[C.C_XW_CL] = 8.5;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 - .5;
                    data[C.C_XB_HC] = 6;
                    data[C.C_XC_SL] = 0;
                    data[C.C_XF_B] = 8.5;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_B) {
                    data[C.C_LW_CL] = 2.5;
                    data[C.C_HYC_BCL] = 2;
                    data[C.C_JK_SW] = -1;
                    data[C.C_XW_CL] = 8;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 - .5;
                    data[C.C_XB_HC] = 5;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 8;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_C) {
                    data[C.C_LW_CL] = 2.5;
                    data[C.C_HYC_BCL] = 2.5;
                    data[C.C_JK_SW] = -.5;
                    data[C.C_XW_CL] = 7.5;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 - .5;
                    data[C.C_XB_HC] = 5;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 7.5;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_D) {
                    data[C.C_LW_CL] = 2;
                    data[C.C_HYC_BCL] = 3;
                    data[C.C_JK_SW] = -.5;
                    data[C.C_XW_CL] = 7;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 - .5;
                    data[C.C_XB_HC] = 4.5;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 7;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_Y) {
                    data[C.C_LW_CL] = 3;
                    data[C.C_HYC_BCL] = 3;
                    data[C.C_JK_SW] = -1.5;
                    data[C.C_XW_CL] = 11;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 - .5;
                    data[C.C_XB_HC] = 7;
                    data[C.C_XC_SL] = 0;
                    data[C.C_XF_B] = 9.5;
                    data[C.C_XK_SO] = 6;
                }
                if (somatotype == C.SOMATOTYPE_T) {
                    data[C.C_LW_CL] = 2;
                    data[C.C_HYC_BCL] = 3;
                    data[C.C_JK_SW] = -.5;
                    data[C.C_XW_CL] = 6;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 - .5;
                    data[C.C_XB_HC] = 5;
                    data[C.C_XC_SL] = .5;
                    data[C.C_XF_B] = 7;
                    data[C.C_XK_SO] = 5;
                }
                break;
            case C.PREFERENCE_LOOSE:
                if (somatotype == C.SOMATOTYPE_A) {
                    data[C.C_LW_CL] = 2.5;
                    data[C.C_HYC_BCL] = 2;
                    data[C.C_JK_SW] = -1;
                    data[C.C_XW_CL] = 8.5;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 6;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 8.5;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_B) {
                    data[C.C_LW_CL] = 2.5;
                    data[C.C_HYC_BCL] = 2;
                    data[C.C_JK_SW] = -1;
                    data[C.C_XW_CL] = 8;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 5;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 8;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_C) {
                    data[C.C_LW_CL] = 2.5;
                    data[C.C_HYC_BCL] = 2.5;
                    data[C.C_JK_SW] = -.5;
                    data[C.C_XW_CL] = 7.5;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 5;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 7.5;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_D) {
                    data[C.C_LW_CL] = 2;
                    data[C.C_HYC_BCL] = 3;
                    data[C.C_JK_SW] = -.5;
                    data[C.C_XW_CL] = 7;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 4.5;
                    data[C.C_XC_SL] = -0.5;
                    data[C.C_XF_B] = 7;
                    data[C.C_XK_SO] = 5;
                }
                if (somatotype == C.SOMATOTYPE_Y) {
                    data[C.C_LW_CL] = 3;
                    data[C.C_HYC_BCL] = 3;
                    data[C.C_JK_SW] = -1.5;
                    data[C.C_XW_CL] = 11;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 8;
                    data[C.C_XC_SL] = 0;
                    data[C.C_XF_B] = 9.5;
                    data[C.C_XK_SO] = 6;
                }
                if (somatotype == C.SOMATOTYPE_T) {
                    data[C.C_LW_CL] = 2;
                    data[C.C_HYC_BCL] = 2.5;
                    data[C.C_JK_SW] = -.5;
                    data[C.C_XW_CL] = 6;
                    data[C.C_ZY_MW] = this.v_yx * 0.26 -.5;
                    data[C.C_XB_HC] = 5;
                    data[C.C_XC_SL] = 0;
                    data[C.C_XF_B] = 7;
                    data[C.C_XK_SO] = 5;
                }
                break;
        }

        return data;
    }

    /**
     * 计算成衣尺寸
     * @param preference
     * @returns {{}}
     */
    getCompleteSize(preference) {
        this.preference = preference;
        // let somatotype = this.custom_somatotype || this.default_somatotype
        let base_size = this.base(this.preference);
        let plus_size = this.plus(this.preference);
        let formulas = this.complete_size[this.preference];

        let result = {};
        for (let key in formulas) {
            let temp =
                Math.round(formulas[key].apply(this, [this.net_size, base_size, plus_size, result]) * 10) / 10;
            result[key] = isNaN(temp) ? 0 : temp;
        }

        return result;
    }

    getBodySize() {
        let result = {};
        for (let key in this.body_size) {
            if (key in this.body)
                result[key] = this.body[key][this.body_size[key]] || 0;
        }

        return result;
    }
}

export default MP;
